export const Indexes = {
  COOKIE: 10,
  MODAL: 3,
  FIXED: 2,
  ABSOLUTE: 1,
  DEFAULT: 0,
};

export const Breakpoint = {
  XS: '320px',
  S: '498px',
  M: '768px',
  L: '1024px',
  XL: '1280px',
};

export const MediaQuery = {
  XS_AND_DOWN: `@media screen and (max-width: ${Breakpoint.XS})`,
  S_AND_DOWN: `@media screen and (max-width: ${Breakpoint.S})`,
  M_AND_DOWN: `@media screen and (max-width: ${Breakpoint.M})`,
  L_AND_DOWN: `@media screen and (max-width: ${Breakpoint.L})`,
  XL_AND_DOWN: `@media screen and (max-width: ${Breakpoint.XL})`,

  XS_AND_UP: `@media screen and (min-width: ${Breakpoint.XS})`,
  S_AND_UP: `@media screen and (min-width: ${Breakpoint.S})`,
  M_AND_UP: `@media screen and (min-width: ${Breakpoint.M})`,
  L_AND_UP: `@media screen and (min-width: ${Breakpoint.L})`,
  XL_AND_UP: `@media screen and (min-width: ${Breakpoint.XL})`,

  S_TO_M: `@media only screen and (min-width: ${Breakpoint.S}) and (max-width: ${Breakpoint.M})`,
  M_TO_L: `@media only screen and (min-width: ${Breakpoint.M}) and (max-width: ${Breakpoint.L})`,
  M_TO_XL: `@media only screen and (min-width: ${Breakpoint.M}) and (max-width: ${Breakpoint.XL})`,
};

export const Shadow = {
  BOX: '0 15px 45px 0 rgba(0, 0, 0, 0.1)',
  BOX_ACTIVE: '0 15px 45px 0 rgba(0, 0, 0, 0.15)',
  DEEP_BOX_ACTIVE: '0 0 10px rgba(0, 0, 0, 0.25)',

  BLUE_BOX: '0 5px 20px 0 rgba(20, 106, 255, 0.1)',
  BLUE_ACTIVE: '0 15px 45px 0 rgba(20, 106, 255, 0.1)',
  DEEP_BLUE_ACTIVE: '0 15px 45px 0 rgba(20, 60, 120, 0.2)',

  HIGH_BLUE_ACTIVE: '0px 30px 45px rgba(20, 106, 255, 0.1)',
};

export const Transition = {
  OPACITY_EASE: 'opacity 0.3s ease-in-out',
  ALL_EASE: 'all 0.25s ease',
  BACKGROUND: 'all 0.25s ease-in-out',
  HOVER: 'transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out',
  HEIGHT: 'height 0.2s',
  HEIGHT_EASE: 'height 0.2s ease 0s',
  TOP: 'top 0.2s',
  SHADOW: 'box-shadow 0.2s ease 0s',
};
